import classNames from './styles.module.scss'


const swiperConfig = {
  spaceBetween: 50,
  slidesPerView: 1,
  slidesPerGroup: 1,
  speed: 0,
  mousewheel: true,
  cssMode: true,
  preventClicks: false,
  preventClicksPropagation: false,
  observer: true,
  observeParents: true,
  className: classNames.swiper,
  clickable: true,
  simulateTouch: false,
}

export default swiperConfig
